// @flow

import React from 'react'
import Toggle from 'react-toggle'

import './slide-toggle.css'

type Props = {
  label: string,
  defaultChecked: boolean,
  onChange: (any) => void,
}

export const RawSlideToggle = (props: Props) =>
  <label className="slide-toggle-label">
    <div className="slide-toggle-label-text">{props.label}</div>
    <Toggle
      checked={props.defaultChecked}
      onChange={props.onChange}
    />
  </label>

export default RawSlideToggle



// WEBPACK FOOTER //
// ./src/controls/slide-toggle.js